<template>
  <div>
    <div class="bg-card">
      <h1>{{ $t('pages.my-account.promos.title', 'Promo codes') }}</h1>
      <div
        v-if="promos.length"
        class="d-flex"
      >
        <PromoCode
          v-for="promo in promos"
          :key="promo.id"
          :code="promo.code"
          :limit="promo.limit"
          :used="promo.used_times"
          :type="promo.type"
          :discount="promo.discount"
        />
      </div>
      <div v-else>
        {{ $t('pages.my-account.promos.no-promos', 'There are no promo codes available') }}
      </div>
    </div>
  </div>
</template>

<script>
import PromoCode from "@/components/jobs/blocks/PromoCode";
export default {
  components: {PromoCode},
  data() {
    return {
      promos: [],
    }
  },

  mounted() {
    this.getMyPromoCodes();
  },

  methods: {
    getMyPromoCodes() {
      this.axios.get('/users/my-promos')
        .then(res => {
          this.promos = res.data;
        })
        .catch();
    }
  }
}
</script>
